import React, { useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import {
  ArrowDropUp,
  ArrowDropDown,
  UnfoldMore,
} from "@mui/icons-material";

const ActivityLog = () => {
  const originalData = [
    {
      date: "12/02/2025",
      time: "22:00:21",
      activity: 'Supplier "canuck cannabis" has been created',
      username: "david@northernthc.com",
    },
    {
      date: "10/02/2025",
      time: "18:15:00",
      activity: 'Supplier "zen labs" has been updated',
      username: "amy@northernthc.com",
    },
    {
      date: "14/02/2025",
      time: "09:45:12",
      activity: 'User "admin" logged in',
      username: "admin@northernthc.com",
    },
  ];

  const [sortConfig, setSortConfig] = useState({ key: "", direction: null });
  const [rows, setRows] = useState(originalData);

  const handleSort = (key) => {
    const isAsc = sortConfig.key === key && sortConfig.direction === "asc";
    const direction = isAsc ? "desc" : "asc";

    const sorted = [...rows].sort((a, b) => {
      let valA = a[key];
      let valB = b[key];

      if (key === "date") {
        valA = new Date(`${a.date} ${a.time}`);
        valB = new Date(`${b.date} ${b.time}`);
      } else {
        valA = valA.toString().toLowerCase();
        valB = valB.toString().toLowerCase();
      }

      if (valA < valB) return direction === "asc" ? -1 : 1;
      if (valA > valB) return direction === "asc" ? 1 : -1;
      return 0;
    });

    setSortConfig({ key, direction });
    setRows(sorted);
  };

  const renderSortableHeader = (label, key) => {
    const isSorted = sortConfig.key === key;
    const direction = isSorted ? sortConfig.direction : null;

    return (
      <Box
        onClick={() => handleSort(key)}
        sx={{ display: "flex", alignItems: "center", gap: 0.5, cursor: "pointer", fontWeight: "bold" }}
      >
        {label}
        {direction === "asc" && <ArrowDropUp />}
        {direction === "desc" && <ArrowDropDown />}
        {!direction && <UnfoldMore />}
      </Box>
    );
  };

  return (
    <Box sx={{ p: 3 }}>
      <TableContainer component={Paper} sx={{ borderRadius: 2, border: "1px solid black" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{borderBottom:"1px solid black"}}>{renderSortableHeader("Date", "date")}</TableCell>
              <TableCell sx={{borderBottom:"1px solid black"}}>{renderSortableHeader("Activity", "activity")}</TableCell>
              <TableCell sx={{borderBottom:"1px solid black"}}>{renderSortableHeader("Username", "username")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, idx) => (
              <TableRow key={idx}>
                <TableCell>{row.date} &nbsp;&nbsp; {row.time}</TableCell>
                <TableCell>{row.activity}</TableCell>
                <TableCell>{row.username}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ActivityLog;
